import { render, staticRenderFns } from "./FriendFavorites.vue?vue&type=template&id=65e3fbdc&"
import script from "./FriendFavorites.vue?vue&type=script&lang=js&"
export * from "./FriendFavorites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports